/* global wp */
import logo from '../images/login/logo.png';
import logo2x from '../images/login/logo@2x.png';
import logo3x from '../images/login/logo@3x.png';
import GoogleForm from './login/google-form';
import LoginForm from './login/login-form';
import { get } from 'lodash';
import SideTabs from './elements/side-tabs';
import Button from './elements/button';

const { useState } = wp.element;

const Login = () => {
	const [selectedTab, changeSelectedTab] = useState(get(
		window,
		'hubConnectorVars.current_tab',
		'register'
	));

	const {
		login_title,
		login_desc,
		create_account_desc,
		new_user,
		existing_user,
		continue_with_email,
		login,
		create_free_account
	} = get(
		window,
		'hubConnectorVars.texts',
		false
	);

	const handleTabChange = (tab) => {
		changeSelectedTab(tab);
	};

	return (
		<main className="sui-wrap">
			<div className="dashui-onboarding">
				<div className="dashui-onboarding-body dashui-onboarding-content-center">
					<div className="dashui-login-form">
						<img
							src={logo}
							srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
							className="dashui-onboarding-logo"
							alt={login}
						/>
						<h2>{login_title}</h2>
						<SideTabs
							value={selectedTab}
							onChange={(tab) => handleTabChange(tab)}
							tabs={{
								register: new_user,
								login: existing_user,
							}}
						/>
						{selectedTab === 'register' && (
							<>
								<p
									dangerouslySetInnerHTML={{__html: create_account_desc}}
								>
								</p>
								<Button
									className="dashui-button"
									href={get(window, 'hubConnectorVars.login.register_url', '')}
								>
									{create_free_account}
								</Button>
							</>
						)}
						{selectedTab === 'login' && (
							<>
								<p>{login_desc}</p>
								<GoogleForm/>
								<div className="form-separator">
									<p className="sui-description">
										{continue_with_email}
									</p>
								</div>
								<LoginForm/>
							</>
						)}
					</div>
				</div>
			</div>
		</main>
	);
};

export default Login;
